// Canonical money policy. Browser copy is generated by sync-fiscal-money.cjs.
/* global BigInt */
const fiscalCents = (value) => {
  const number = Number(value ?? 0);
  return Number.isFinite(number) ? Math.round((number + Number.EPSILON) * 100) : 0;
};
const draftTotals = (form) => {
  const items = form.items || [];
  const products = items.reduce((sum, item) => sum + fiscalCents(Number(item.quantity || 0) * Number(item.unitPrice || 0)), 0);
  const discount = items.reduce((sum, item) => sum + fiscalCents(item.discount), 0);
  const freight = fiscalCents(form.freight), insurance = fiscalCents(form.insurance), other = fiscalCents(form.other);
  return {products: products / 100, discount: discount / 100, freight: freight / 100,
    insurance: insurance / 100, other: other / 100, invoice: (products - discount + freight + insurance + other) / 100};
};

// Gross product values are weights; floor shares and leave residual cents to the last positive item.
const allocateFiscalCharge = (items, value) => {
  const amount = fiscalCents(value);
  if (!Number.isSafeInteger(amount) || amount < 0) throw new Error('Valor de acréscimo fiscal inválido.');
  const weights = items.map((item) => Math.max(0, fiscalCents(item.total)));
  const total = weights.reduce((sum, weight) => sum + weight, 0);
  const last = weights.findLastIndex((weight) => weight > 0);
  if (amount > 0 && (!Number.isSafeInteger(total) || last < 0)) throw new Error('Frete/acréscimos: não há valor de produtos válido para rateio.');
  let remainder = amount;
  return weights.map((weight, index) => {
    const share = index === last ? remainder : total > 0 ? Number(BigInt(amount) * BigInt(weight) / BigInt(total)) : 0;
    remainder -= share;
    return share / 100;
  });
};
const allocateFiscalCharges = (items, totals) => {
  const shares = Object.fromEntries(['freight', 'insurance', 'other'].map((field) => [field, allocateFiscalCharge(items, totals[field])]));
  return items.map((item, index) => ({...item, freight: shares.freight[index], insurance: shares.insurance[index], other: shares.other[index]}));
};

export {fiscalCents, draftTotals, allocateFiscalCharge, allocateFiscalCharges};
